import { useState } from 'react';
import { PenLine, Table2 } from 'lucide-react';

import MedicinaAtestadosLancamento from './MedicinaAtestadosLancamento';
import MedicinaAtestadosConsulta from './MedicinaAtestadosConsulta';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

// =============================================================================
// Medicina do Trabalho — SUB-MÓDULO "Revisão de Atestados".
//
// Mesmo padrão do Petty Cash / Troco no Financeiro: o módulo tem um card, o
// card abre este sub-hub, e aqui dentro ficam as telas do processo.
//   - Lançamento → o médico registra o atestado e os dias que concedeu;
//   - Consulta   → os números (Loja → Cargo → Nome), Total e >1 dia.
//
// Permissão fina mora aqui (o hub só decide quem entra no sub-módulo):
// lançar é do médico; consultar inclui RH e gerente.
// =============================================================================

const VERDE = '#16a34a';
const VERDE_CLARO = '#dcfce7';

const PODE_LANCAR = ['Medico', 'Diretoria', 'Admin'];

const MedicinaRevisaoAtestados = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const podeLancar = PODE_LANCAR.includes(perfilNoModulo(user?.perfil, 'medicina'));

  // Quem não lança (RH, Gerente) cai direto na Consulta — abrir numa aba que
  // ele não tem seria uma tela vazia na cara.
  const [abaAtiva, setAbaAtiva] = useState(podeLancar ? 'lancamento' : 'consulta');

  const estiloAba = (ativa) => ({
    display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px',
    backgroundColor: ativa ? VERDE_CLARO : 'transparent',
    color: ativa ? VERDE : '#334155',
    border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
    transition: 'all 0.2s', fontSize: 14,
  });

  const renderAba = () => {
    if (abaAtiva === 'lancamento' && podeLancar) return <MedicinaAtestadosLancamento embedded />;
    return <MedicinaAtestadosConsulta />;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, borderBottom: '1px solid #e2e8f0', paddingBottom: 16 }}>
        {podeLancar && (
          <button onClick={() => setAbaAtiva('lancamento')} style={estiloAba(abaAtiva === 'lancamento')}>
            <PenLine size={18} /> Lançamento
          </button>
        )}
        <button onClick={() => setAbaAtiva('consulta')} style={estiloAba(abaAtiva === 'consulta')}>
          <Table2 size={18} /> Consulta
        </button>
      </div>

      <div style={{ paddingTop: 8 }}>{renderAba()}</div>
    </div>
  );
};

export default MedicinaRevisaoAtestados;
